import React from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router';

import LoginForm from '../components/LoginForm';
import {tokenObtainPair} from '../actions/auth';
import {authErrors, isAuthenticated} from '../reducers/auth';

const Login = (props) => props.isAuthenticated
    ? <Redirect to="/"/>
    : <LoginForm {...props}/>;

export default connect(
    ({auth}) => ({errors: authErrors(auth), isAuthenticated: isAuthenticated(auth)}),
    {tokenObtainPair}
)(Login);


// WEBPACK FOOTER //
// ./src/containers/Login.js